import DrawerAppBar from "./Navbar";
import MenuDasbord from "./dashbodMenu";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";

function Indexdasbord({ Children }) {
  const { IsAuth } = useSelector((state) => state.Auth);
  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#f7f7f7" }}>
      <DrawerAppBar />
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <Box
          sx={{
            marginTop: "100px",
            display: "flex",
            flexDirection: "row",
          }}
        >
          {IsAuth && (
            <Box>
              <MenuDasbord />
            </Box>
          )}

          <Box width="100%">{Children}</Box>
        </Box>
      </Box>
    </div>
  );
}

export default Indexdasbord;
